import { render, staticRenderFns } from "./FeedBackOnekids.vue?vue&type=template&id=88f1b0aa&scoped=true"
import script from "./FeedBackOnekids.vue?vue&type=script&lang=js"
export * from "./FeedBackOnekids.vue?vue&type=script&lang=js"
import style0 from "./FeedBackOnekids.vue?vue&type=style&index=0&id=88f1b0aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f1b0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88f1b0aa')) {
      api.createRecord('88f1b0aa', component.options)
    } else {
      api.reload('88f1b0aa', component.options)
    }
    module.hot.accept("./FeedBackOnekids.vue?vue&type=template&id=88f1b0aa&scoped=true", function () {
      api.rerender('88f1b0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/FeedBackOnekids.vue"
export default component.exports